import(/* webpackMode: "eager", webpackExports: ["PageLoader"] */ "/app/next/src/components/ui/Loader.tsx");
